import { render, staticRenderFns } from "./BaseRating.vue?vue&type=template&id=2a4bb38f"
import script from "./BaseRating.vue?vue&type=script&lang=js"
export * from "./BaseRating.vue?vue&type=script&lang=js"
import style0 from "./BaseRating.vue?vue&type=style&index=0&id=2a4bb38f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports